export const appRoutes = [
  'foshanplus://timeline/moment/detail', // 友趣详情 0
  'foshanplus://timeline/moment/category', // 友趣频道 1
  'foshanplus://timeline/moment/tag', // 友趣话题 2
  'foshanplus://timeline/ask/tag', // 问吧话题 3
  'foshanplus://timeline/ask/detail', // 问吧详情 4
  'foshanplus://timeline/report/detail', // 找记者详情页面 5
  'foshanplus://timeline/take/detail', // 全民拍详情页面 6
  'foshanplus://timeline/take/category', // 全民拍频道 7
  'foshanplus://timeline/take/tag', // 全民拍话题 8

  'foshanplus://timeline/neighbor/detail', // 友邻详情 9
  'foshanplus://timeline/neighbor/category', //友邻频道 10
  'foshanplus://timeline/neighbor/tag' // 友邻话题
]
